import Fetcher from "../utils/Fetcher";
import Consts from "../commons/Consts";

const AuthService = {

    login(data) {
        return Fetcher.post(`${Consts.baseapi}/login`, data);
    },

    signup(data) {
        return Fetcher.post(`${Consts.baseapi}/register`, data);
    },

    sendRestoreOtp(data) {
        return Fetcher.post(`${Consts.baseapi}/restore-password`, data);
    },

    restorePassword(data) {
        return Fetcher.put(`${Consts.baseapi}/restore-password`, data);
    },

    logout() {
        return Fetcher.post(`${Consts.baseapi}/logout`);
    }

};

export default AuthService;
